import React from 'react';
import SourceConfidencePanel from '../SourceConfidencePanel';

// Stage 2: the corroboration behind the concept's regulatory claims.
//
// The panel itself carries the propose / recheck / six-check / note / remove controls; this
// stage exists so that work has a place of its own instead of being one section of a ten
// section scroll.
export default function SourcesStage({ concept, conceptId, isDirector, onChanged }) {
  return (
    <div>
      <p className="text-[11px] text-[#8a95a8] mb-3">
        JPRO proposes official sources from a live search and checks that every link
        resolves before storing it. Confirming the six checks on at least one source is what
        clears this concept for review.
      </p>
      <SourceConfidencePanel concept={concept} conceptId={conceptId}
        isDirector={isDirector} onChanged={onChanged} />
    </div>
  );
}
